import { render, staticRenderFns } from "./Art.vue?vue&type=template&id=2f74eb96&"
import script from "./Art.vue?vue&type=script&lang=js&"
export * from "./Art.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports